import { useTranslation } from "react-i18next"
import { useGetAllWorkerContractsQuery } from "./api/workContractApiSlice"
import PageLayout from "components/layout/PageLayout"
import WorkerContractTable from "./components/WorkerContractTable"

const WorkerLeaveLeft = () => {

    const [t] = useTranslation(["global", "absenceReport"])
    const {
        data: workerContracts,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetAllWorkerContractsQuery()

    let content

    if (isSuccess)
        content =
            <>
                <div>
                    <div className="card bg-black bg-opacity-10 text-white mb-4 text-center">
                        <div className="card-body">
                            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                                <div className="col p-2">
                                    <span className="text-muted"> {t("absenceReport:label.active_contracts")}</span>
                                    <h3 className="p-2"><i className="fa-regular fa-address-book"></i> {workerContracts.items.length}</h3>
                                </div>
                                <div className="col p-2">
                                    <span className="text-muted">{t("absenceReport:label.weekly_work_hours_total")}</span>
                                    <h3 className="p-2"><i className="fa-solid fa-users"></i> {Math.round(workerContracts.stats.total)} {t("unit.hours")} </h3>
                                    <span >{(Math.round(workerContracts.stats.total) / 40).toFixed(1)} <b className="text-accent">FTE</b> </span>
                                </div>
                                <div className="col p-2">
                                    <span className="text-muted">{t("absenceReport:label.weekly_work_hours_average")}</span>
                                    <h3 className="p-2"><i className="fa-solid fa-user"></i> {Math.round(workerContracts.stats.average)} {t("unit.hours")}</h3>
                                    <span>{(Math.round(workerContracts.stats.average) / 40).toFixed(1)} <b className="text-accent">FTE</b> </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <WorkerContractTable workersData={workerContracts.items} />
            </>

    return <PageLayout
        pageTitle={t("absenceReport:menu.leave_balances")}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
        bodyContent={content}
    />
}

export default WorkerLeaveLeft